import { render, staticRenderFns } from "./addStudentSimple.vue?vue&type=template&id=0a7d6abd&"
import script from "./addStudentSimple.vue?vue&type=script&lang=js&"
export * from "./addStudentSimple.vue?vue&type=script&lang=js&"
import style0 from "./addStudentSimple.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports